import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import EditIcon from '@material-ui/icons/Edit'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { LAYOUT_DRAWER_TABS_TOOLS_ANNOTATIONS_EXPANDED } from 'api/actions'
import * as Model from 'api/model'
import AccordionWrapper from 'drawer/tabs/AccordionWrapper'
import LayerPanelEdit from 'drawer/tabs/layers/annotations/LayerPanelEdit'
import { PANEL_TITLE_DRAW } from 'drawer/tabs/layers/panels/LayerPanels'
import Upgrade from 'drawer/tabs/Upgrade'

const styles = theme => ({
  root: {}
})

class AnnotationsNew extends React.Component {
  constructor (props) {
    super(props)
    this.pure = {}
    this.pure.title = PANEL_TITLE_DRAW
    this.pure.headerIcon = <EditIcon /> // If you change this, change it in LayerPanelEdit
    this.pure.upgradeText = Model.get('config.layout.drawer.tabs.tools.annotations.upgrade.text', 'Upgrade to Pozi Enterprise')
    this.pure.upgradeURL = Model.get('config.layout.drawer.tabs.tools.annotations.upgrade.url', '')
    this.pure.upgradeURLLabel = Model.get('config.layout.drawer.tabs.tools.annotations.upgrade.urlLabel', 'Learn More')
    this.pure.upgradeMarkup = <Upgrade text={this.pure.upgradeText} url={this.pure.upgradeURL} urlLabel={this.pure.upgradeURLLabel} />
  }

  render () {
    const { classes, layer, bEditEnabled, bLayerEditEnabled, toggleExpansionPanel, expanded } = this.props
    if (!bEditEnabled || !bLayerEditEnabled) {
      return (
        <div className={classes.root}>
          <AccordionWrapper
            expanded={expanded}
            licensed={false}
            onChange={toggleExpansionPanel}
            headerIcon={this.pure.headerIcon}
            title={this.pure.title}
            bExcludeExpandIcon={false}
          >
            {this.pure.upgradeMarkup}
          </AccordionWrapper>
        </div>
      )
    }

    return (
      <LayerPanelEdit map={window.appObject.map} titleid={layer.titleid} toggleExpansionPanel={toggleExpansionPanel}/>
    )
  }
}

AnnotationsNew.propTypes = {
  classes: PropTypes.object.isRequired,
  layer: PropTypes.object,
  bEditEnabled: PropTypes.bool.isRequired,
  bLayerEditEnabled: PropTypes.bool.isRequired,
  toggleExpansionPanel: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired
}

function mapStateToProps (state, ownProps) {
  const annotationsTitleId = Model.ANNOTATION_LAYER_TITLEID
  const layer = get(state, 'layers[' + annotationsTitleId + ']')
  const bLayerEditEnabled = get(layer, 'edit', false)
  const bEditEnabled = get(state, 'config.layout.drawer.tabs.tools.annotations.enabled', true)
  const expanded = get(state, 'config.' + LAYOUT_DRAWER_TABS_TOOLS_ANNOTATIONS_EXPANDED, false)

  return {
    bEditEnabled,
    bLayerEditEnabled,
    layer,
    expanded
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(AnnotationsNew)
  )
)
